import { render } from "./DosePrice.vue?vue&type=template&id=2d945087&scoped=true&ts=true"
import script from "./DosePrice.vue?vue&type=script&lang=ts"
export * from "./DosePrice.vue?vue&type=script&lang=ts"

import "./DosePrice.vue?vue&type=style&index=0&id=2d945087&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d945087"]])

export default __exports__